import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 24 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ eyebrow, title, text, dark = false, className = "" }) {
  return (
    <Reveal className={`max-w-2xl ${className}`}>
      {eyebrow && <span className={`eyebrow ${dark ? "text-gold" : "text-mint-600"}`}><span className="h-px w-8 bg-current" />{eyebrow}</span>}
      <h2 className={`mt-4 text-3xl font-bold sm:text-4xl ${dark ? "text-white" : "text-navy"}`}>{title}</h2>
      {text && <p className={`mt-4 text-base md:text-lg ${dark ? "text-slate-400" : "text-slate-600"}`}>{text}</p>}
    </Reveal>
  );
}

export function PageHero({ eyebrow, title, text, children }) {
  return (
    <section className="grain relative overflow-hidden bg-navy pb-20 pt-16 sm:pt-24">
      <div className="grid-lines absolute inset-0" />
      <div className="aurora absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full bg-mint/15 blur-[120px]" />
      <div className="aurora absolute -bottom-40 left-10 h-[360px] w-[360px] rounded-full bg-gold/10 blur-[120px]" />
      <div className="container-q relative">
        <Reveal>
          {eyebrow && <span className="eyebrow text-gold"><span className="h-px w-8 bg-current" />{eyebrow}</span>}
          <h1 className="mt-5 max-w-4xl text-4xl font-extrabold leading-tight text-white sm:text-5xl lg:text-6xl">{title}</h1>
          {text && <p className="mt-6 max-w-2xl text-base text-slate-400 md:text-lg">{text}</p>}
          {children}
        </Reveal>
      </div>
    </section>
  );
}
